import { useEffect } from "react";

const AddressesMap = ({ setMap, setGeocoder, setInfoWindow }) => {
  const options = {
    zoom: 15,
    disableDefaultUI: true,
    fullscreenControl: true,
    styles: [
      {
        featureType: "poi",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit.station.bus",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit.station.airport",
        stylers: [{ visibility: "off" }],
      },
    ],
  };

  function onScriptLoad() {
    const infoWindow = new window.google.maps.InfoWindow();
    setInfoWindow(infoWindow);

    const googleGeocoder = new window.google.maps.Geocoder();
    setGeocoder(googleGeocoder);

    const googleMap = new window.google.maps.Map(document.getElementById("myMap"), options);
    setMap(googleMap);
  }

  function addGoogleMapsScript() {
    if (!window.google?.maps) {
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src = `https://maps.google.com/maps/api/js?key=${process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY}&libraries=geometry,places`;

      const x = document.getElementsByTagName("script")[0];
      x.parentNode.insertBefore(s, x);

      s.addEventListener("load", () => {
        onScriptLoad();
      });
    } else {
      onScriptLoad();
    }
  }

  useEffect(() => {
    addGoogleMapsScript();
  }, []);

  return (
    <div className="w-100">
      <div
        id="myMap"
        className="w-100"
        style={{ height: "500px" }}
      />
    </div>
  );
};

export default AddressesMap;
